import { logger } from '@benzinga/logging';

export function logCalendarFetchFailure(calendar: string, error: unknown): void {
  logger.error(`Calendar ${calendar} fetch failed`, error, {
    calendar,
    event: 'calendar_fetch_failed',
  });
}
